import React from 'react';
import { ATMModal, ATMButton, ATMHeader } from 'shared-it-appmod-ui';
import Lang from 'src/libraries/language';
import styles from '../fire-dispatch-list.module.scss';

const SwitchButtonStyle = ({ secondary, handleOpen }) => {
  if (secondary) {
    return (
      <ATMButton
        secondary
        icon="mail outline"
        onClick={() => handleOpen(true)}
        content="Send Notification"
      />
    );
  }

  return (
    <ATMButton
      className={styles.actionIcon}
      basic
      icon="mail outline"
      onClick={() => handleOpen(true)}
    />
  );
};

type IProp = {
  isOpen: boolean;
  handleOpen: (value: boolean) => void;
  handleSend: () => void;
  secondary?: boolean;
};
const FireDispatchEmailNotificationView: React.FC<IProp> = ({
  isOpen,
  handleOpen,
  handleSend,
  secondary,
}) => {
  return (
    <ATMModal
      open={isOpen}
      size="tiny"
      trigger={
        <SwitchButtonStyle secondary={secondary} handleOpen={handleOpen} />
      }
      content={
        <div
          style={{
            padding: '2em',
          }}
        >
          <ATMHeader
            as="h3"
            content={Lang.MSG_DISPATCH_EMAIL_NOTIFICATION_TITLE}
          />
          <br />
          {Lang.MSG_DISPATCH_EMAIL_NOTIFICATION}
        </div>
      }
      actions={
        <div
          style={{
            textAlign: 'right',
            padding: '1em 1.5em',
          }}
        >
          <ATMButton
            basic
            color="blue"
            content={Lang.LBL_NO}
            onClick={() => handleOpen(false)}
          />
          <ATMButton
            primary
            content={Lang.LBL_YES}
            onClick={() => {
              handleOpen(false);
              handleSend();
            }}
          />
        </div>
      }
    />
  );
};

export default FireDispatchEmailNotificationView;
